import Model, { attr } from '@ember-data/model';

import type { DateRangeInterface, DSSetup, Slack } from 'webapp-types';
import type { AlertEventCondition, DeliveryType, EventDeliveryTime } from 'webapp/enums/enums';

export default class AlertRecord extends Model {
	@attr('string') name!: string;
	@attr('number') parentId!: number | null;
	@attr('number') metricId!: number | null; // just for BE's sake - does not get changed on FE
	@attr('number') blockId!: number; // does not get changed on FE

	@attr('string') metricSetupKey!: string;
	@attr('number') metricSetupSpaceAccessId!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	metricSetupDimensions!: string[];
	@attr('object') metricSetupFilters!: DSSetup.MetricSetupFiltersData | null;

	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	dateRange!: DateRangeInterface.FormulaInterface;
	@attr('number') dataSourceId!: number | null;
	@attr('boolean') inactive!: boolean;
	@attr('number') condition!: AlertEventCondition;
	@attr('number') qualifier!: number | null;
	@attr('number', { defaultValue: 1 }) deliveryTime!: EventDeliveryTime;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	deliveryType!: DeliveryType[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	slackChannels!: Slack.Channels;
	@attr('string', { defaultValue: '' }) template!: string;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	userIds!: number[];
	@attr('number') created!: number;
	@attr('number') createdById!: number;
}
